import { useEffect } from "react";
import { use_store } from "../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";

export const Error = () => {
  const { error, set_error } = use_store();

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        set_error(null);
      }, 6 * 1000);

      return () => clearTimeout(timer);
    }
  }, [error, set_error]);

  if (!error) return null;

  return (
    <div className="fixed bottom-[12px] right-[12px] bg-red-600 text-surface p-[28px] rounded-[4px] max-w-[400px] shadow-2xl border-[1px] border-lines">
      <button
        onClick={() => set_error(null)}
        className="absolute top-[0px] right-[0px] p-[8px] text-surface hover:text-primary transition-colors cursor-pointer"
      >
        <FontAwesomeIcon icon={faTimes} className="bigt" />
      </button>
      <p className="bigt smallt mr-[12px]">{error}</p>
    </div>
  );
};
